import React, { useEffect, useRef, useState } from 'react'

import { Radio as AntRadio } from 'antd'

import './styles/radio.less'

export interface Props {
  size?: 'large' | 'small' | 'middle'
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>
  disabled?: boolean
  defaultValue?: string | number | boolean
  onChange?: any
  children?: any
  value?: any
  className?: string
  name?: string
  contentAlign?: 'start' | 'end' | 'center'
}

const sizes = {
  large: 'size-lg',
  middle: 'size-md',
  small: 'size-sm',
}

export const Radio = (props: Props) => <AntRadio {...props} />

const RadioButton: React.FC<Props> = ({ children, className = '', contentAlign = 'center', ...props }) => {
  const ref = useRef(null)

  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (ref?.current) {
      setChecked(!!ref.current.input?.checked)
    }
  }, [ref.current])

  return (
    <AntRadio.Button
      ref={ref}
      className={`radio h-100 w-100 flex flex align-center ${sizes[props.size]} ${className}`}
      {...props}
    >
      <div className={`child w-100 flex space-between gap-10 p-16 h-100 t-radio-button-div align-${contentAlign}`}>
        {children}
        <div>{checked ? <i className="fas fa-dot-circle"></i> : <i className="fal fa-circle color-gray-6"></i>}</div>
      </div>
    </AntRadio.Button>
  )
}
Radio.Button = RadioButton

Radio.Group = ({ className = '', ...props }) => <AntRadio.Group className={`w-100 ${className}`} {...props} />

export default Radio
